import { render, staticRenderFns } from "./GradingPage.vue?vue&type=template&id=4136c6f6&scoped=true"
import script from "./GradingPage.vue?vue&type=script&lang=js"
export * from "./GradingPage.vue?vue&type=script&lang=js"
import style0 from "./GradingPage.vue?vue&type=style&index=0&id=4136c6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136c6f6",
  null
  
)

export default component.exports